import { createApp } from 'vue';
import cmpSuperBundles from '../vue/SuperBundles.vue';

window.SuperBundles = (function(){
	const component = createApp(cmpSuperBundles, {});
	return component.mount('#component-super-bundles');
})();
